module.exports = {
	"NODE_ENV": "development",
	"hostname": "localhost",
	"port": 9091,
	"apiEndpoint": "http://localhost:8080",
	"eslint": true,
	"devTool": "source-map",
	"title": "Scala Italy 2017",
	"debug": "app*,*API*,revenge*,Avenger"
};


//////////////////
// WEBPACK FOOTER
// ./config.json
// module id = 215
// module chunks = 0